export enum LeoDashboardAnalysisType {
  DATA = 'data',
  STRUCTURAL = 'structural',
}
